import React from 'react'
import {Link} from 'react-router-dom'

const Login = () => {
  return (

    <div className="min-h-full lg:bg-light-blue white-space-normal overflow-y-hidden container mx-auto">
    <div className=" bg-white lg:bg-light-blue   h-screen w-full grid place-items-center overflow-y-hidden pb-0  ">
    <div className="bg-white lg:shadow-lg rounded-lg w-full h-auto lg:w-96 p-6">
 {/* header */}
 <div className="flex flex-col justify-center items-center h-24 w-full ">
     <h1 className="font-poppins font-semi-bold text-2xl" >
     Login
     </h1>
     <div className="underline" />
 </div>
 {/* Form */}
 
   {/* Email */}
   <div className="flex flex-col   w-full mt-2  ">
      <label className="font-poppins font-medium text-base mb-2" >
      Email
      </label>
      <input className="bg-light-blue  text-base px-4 py-2 focus:outline-none  w-full" type="text" placeholder="Email" />
        </div>
        {/* Password */}
        <div className="flex flex-col   w-full mt-2  ">
      <label className="font-poppins font-medium text-base mb-2" >
      Password
      </label>
      <input className="bg-light-blue  text-base px-4 py-2 focus:outline-none  w-full" type="text" placeholder="Password" />
        </div>
     {/* Remeber me */}
      <div className="flex align-center    w-full mt-2  ">
      <input className="mr-2 mt-1 bg-tradr-green p-4" type="checkbox" />
      <label className="font-poppins font-medium text-base mb-2" >
      Remember me
      </label>
      </div>
          {/* Submit */}
          <div className="flex flex-col bg-tradr-green  w-full mt-2  ">
          <Link className="btn-lg  flex justify-center align-center  " to="/" >
          LOG IN
          </Link>
    </div>
    {/* FORGOT PASSWORD */}
    <div className="flex  w-full mt-4  items-center flex-col ">
    <Link to="/reset-password" className="font-poppins font-medium text-gray text-tiny mb-2" >
    Forgot password?
    </Link>
    <Link to="/register" className="font-poppins font-medium flex text-gray text-tiny mb-2" >
      Dont have an account  <span className="font-poppins text-black font-bold text-tiny mb-2 ml-1" >
        Create an Account </span>
    </Link>
    </div>
    </div>
     </div>
     </div>
  )
}

export default Login